import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: ${(props) => props.theme.colors.white2};
`;

export const Content = styled.div`
  display: inline-flex;
  height: 100%;
`;
